// extracted by mini-css-extract-plugin
export default {"wrapper":"_5RHBu561aB2ZzfqJrIFC1w==","sectionWrapper":"_2jwWgfRLctnjWdtajJ99ZQ==","divider":"GlJTOmLDTuD6UmpmlztDXg=="};